import { render, staticRenderFns } from "./NetaMultiEventBasicDataComponent.vue?vue&type=template&id=79cbf8d9&scoped=true&"
import script from "./NetaMultiEventBasicDataComponent.vue?vue&type=script&lang=js&"
export * from "./NetaMultiEventBasicDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaMultiEventBasicDataComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NetaMultiEventBasicDataComponent.vue?vue&type=style&index=1&id=79cbf8d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cbf8d9",
  null
  
)

export default component.exports